<template>
    <button :class="{ 'editing': isEditing, 'notEditing': !isEditing }">
        <span class="material-symbols-outlined checkmark" v-if="isEditing">
            check
        </span>
        <span class="material-symbols-outlined" v-else>
            edit
        </span>
    </button>
</template>

<script>
export default {
    name: "EditButton",
    props: {
        isEditing: Boolean
    }
};
</script>

<style scoped>
button {
    border: none;
    border-radius: 9999px !important;
    cursor: pointer;
    color: #ffffff;
    margin: 0 !important;
    margin-left: 0.5rem !important;
    padding: 0.3rem 0.4rem;
    display: inline-block;
    transition: 300ms;
}


.editing {
    background-color: #28a745;
    padding-bottom: 0.18rem;
    padding-top: 0.4rem;
}

.notEditing {
    background-color: #007bff;
}
</style>
